import * as React from 'react'
import { Query } from 'react-apollo'
import { RouteComponentProps, withRouter } from 'react-router-dom'

import BookmarkAuthModal from 'main/components/lead/BookmarkButton/BookmarkAuthModal'
import { User_user } from 'main/gql/user'
import { NAV_MODALS } from 'main/hooks/useSSOContext'

import useNavContextModal from '../common/useNavContextModal'
import Bookmarked from './Bookmarked'
import { AddToFavorites as AddToFavoritesData } from './gql/__generated__/AddToFavorites'
import { ADD_TO_FAVORITES_QUERY } from './gql/gql'
import Unbookmarked from './Unbookmarked'

interface IProps extends RouteComponentProps {
  full: boolean
  schoolId: number
}

function AddToFavorites(props: IProps) {
  const { full, schoolId, location } = props

  const [isModalOpen, openModal, closeModal] = useNavContextModal(
    NAV_MODALS.ADD_FAV,
    location.pathname,
  )

  return (
    <>
      <Query<AddToFavoritesData> query={ADD_TO_FAVORITES_QUERY}>
        {({ data, loading }) => {
          const lead = ((data && data.leads) || []).find(l => l.schoolId === schoolId)
          const isBookmarked = lead ? lead.isBookmarked : false
          if (loading) return null
          return renderButton(isBookmarked, data ? data.user : null)
        }}
      </Query>

      {isModalOpen && <BookmarkAuthModal schoolId={schoolId} onRequestClose={() => closeModal()} />}
    </>
  )

  function renderButton(isBookmarked: boolean, user: User_user | null) {
    return isBookmarked ? (
      <Bookmarked full={full} schoolId={schoolId} user={user} onClick={() => openModal()} />
    ) : (
      <Unbookmarked full={full} schoolId={schoolId} user={user} onClick={() => openModal()} />
    )
  }
}

export default withRouter(AddToFavorites)
